export const getters = {
  getProjectType(state) {
    return state.projectType
  },
};
